import {Layout} from '@di-nxt/components';
import React from 'react';

export const SectionBorder: React.FC = () => {
  return (
    <Layout
      flex
      paddingVertical="10"
      borderBottomColor="border_mono_15"
      borderBottomWidth="1"
      borderBottomStyle="solid"
    />
  );
};
